$(document).ready(function($) {

    if (! $('#mapCanvasProperties').length) return;
        window.mapView = {};

        window.mapDone = function(map) {

            window.mapView.currentPage = 1;
            window.mapView.map = map;
            window.mapView.markers = [];

            window.cluster = new MarkerClusterer(window.mapView.map, window.mapView.markers);
            window.cluster.setMaxZoom(14);
            window.mapView.oms = new OverlappingMarkerSpiderfier(window.mapView.map, {keepSpiderfied: true});

            $('#filter').trigger('filter:refresh');

            var iw = new google.maps.InfoWindow();

            window.mapView.oms.addListener('click', function(marker, e) {
                var moreid = 'more_'+marker.pid;
                iw.setContent('<div id="'+moreid+'" class="map-popup">Loading</div>');
                iw.open(window.mapView.map, marker);

                window.loadMoreContent(moreid, marker.pid);
            });

            window.mapView.oms.addListener('spiderfy', function(markers) {
                iw.close();
            });
        }


        $('#show_more').on('click', function(){
            var next = window.mapView.currentPage+1;
            $('#filter').trigger('filter:pagechange');
            var $input = $('input[name=page]').first();
            $input.val(next);
            $input.trigger("change");
        });

        window.loadMoreContent =  function(targetid, pid){
            var $target = $('#'+targetid);
            var url = $('#filter-result').data('more');
            url = url.replace('-pid-', pid);

            var $xhr = $.get(url)
                    .done(function(data){
                        $target.html(data);
                    })
                    .fail(function(){

                    })
                    .always(function(){

                    })
                ;

        }

        window.mapDataHandler = function(data){

            var list = [];
            var imageUrl = 'http://chart.apis.google.com/chart?cht=mm&chs=24x32&chco=FFFFFF,008CFF,000000&ext=.png';
            if (data.items.current_page == 1){
                window.cluster.clearMarkers();
                window.mapView.oms.clearMarkers();
            }

            window.mapView.currentPage = data.items.current_page;

            if (data.items.next_page_url){
                $('#show_more').removeClass('hidden');
            }else{
                $('#show_more').addClass('hidden');
            }

            for (var i = 0; i < data.items.data.length; i++) {
                var item = data.items.data[i];
                var latLng = new google.maps.LatLng(item.latitude, item.longitude);
                var markerImage = new google.maps.MarkerImage(imageUrl, new google.maps.Size(24, 32));


                var marker = new google.maps.Marker({
                    'position': latLng,
                    'pid': item.id,
                   // 'icon': markerImage
                });

                list.push(marker);
                //window.mapView.markers.push(marker);
                window.mapView.oms.addMarker(marker);

            }

            window.cluster.addMarkers(list);
            if (data.items.current_page == 1 && data.items.data.length) {
                window.cluster.fitMapToMarkers();
            }
        }

    });



